import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const LightingIcon = (props) => (
    <SvgIcon {...props}>
        <path d="M18.1,0L4.4,13.6h5.1L5.6,24l14-13.6h-5.1L18.1,0z"/>
    </SvgIcon>
);

export default LightingIcon;